/* eslint-env es6 */
import Keyboard     from '../lib/keyboard.es6';
import template  from './selection-copy.hbs';
import style     from 'selection-copy.scss';
import Overlay from 'overlay';


const INIT_STATE = {
    success: false,
    insert: false,
    hide: false,
    show: false,
    fail: false
};

export default Backbone.View.extend({
    template,
    tagName: 'button',
    className: 'clipboardTrigger',
    initialize (options, bufferView) {
        this.bufferView = bufferView;
    },
    events: {
        'buttonClick': 'onClick'
    },
    setState (state) {
        this.state = state;
        this.update();
    },
    extendState (updates) {
        this.setState(_.extend({}, this.state, updates));
    },
    setInitState () {
        this.setState(INIT_STATE);
    },
    showTextareaOverlay () {
        var overlayTextarea = $('<textarea class="clipboardOverlayTextarea">').val(this.textarea.value);
        var overlay = new Overlay(overlayTextarea, {
            prompt: true,
            head: 'Selected lines <span class="explanation">— automatic copying unavailable</span>',
            keepFocus: true,
            afterAppend: _.bind(function () {
                overlayTextarea.focus().select();
            }, this)
        });
        this.bufferView.trigger('addOverlay', overlay);
    },
    update () {
        if (this.state.success || this.state.fail) {
            this.state.hide = true;
        }
        
        if (this.state.fail) {
            this.showTextareaOverlay();
        }
        
        this.$el.toggleClass('clipboardTrigger--success', this.state.success);
        this.copyAction.toggleClass('clipboardTriggerAction--hide', this.state.insert);
        this.insertAction.toggleClass('clipboardTriggerAction--hide', !this.state.insert);
        
        if (this.state.hide || this.state.show) {
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
            }
            this.$el.stop(true, true);
        }
        
        if (this.state.hide) {
            // Blur and clear the textarea
            this.textarea.value = '';
            
            if (this.state.success && !this.state.insert) {
                this.hideTimeout = setTimeout(_.bind(function () {
                    this.hideTimeout = null;
                    this.$el.fadeOut('fast', _.bind(function () {
                        this.setInitState();
                    }, this));
                }, this), 1000);
            } else {
                this.$el.hide();
                this.setInitState();
            }
        } else if (this.state.show) {
            this.$el.show();
        }
    },
    render () {
        // This has a significant cost if done at initialisation time
        this.textarea = $('.clipboardHelper')[0];
        this.$el.html(this.template());
        this.copyAction = this.$('.clipboardTriggerAction--copy');
        this.insertAction = this.$('.clipboardTriggerAction--insert');
        
        this.setInitState();
        
        // Setup selection change
        this.bufferView.on('textSelectionChange', this.onSelectionChange, this);
        this.bufferView.on('docKeyUp', this.onKeyUp, this);
        this.bufferView.on('docKeyDown', this.onKeyDown, this);
    },
    setInsert (val) {
        this.extendState({insert: val});
    },
    onKeyDown (e) {
        if (!this.state.hide) {
            this.setInsert(Keyboard.isModifier(e));
        }
    },
    onKeyUp (e) {
        if (!this.state.success) {
            this.setInsert(false);
        }
    },
    onClick (e) {
        this.gatherText();
        
        if (this.state.insert) {
            var insertVal = this.textarea.value;
            this.success(true);
            if (insertVal) {
                this.model.trigger('insertAtCursor', insertVal, true);
            }
        } else {
            this.copy().then((success) => {
                this.success(success);
            });
        }
    },
    success (success) {
        if (success) {
            this.extendState({success: true});
        } else {
            this.extendState({fail: true});
        }
    },
    copy () {
        this.textarea.select();
        var val = this.textarea.value;
        let promise = new Promise(function (resolve, reject) {
            // Async clipboard access, available with chrome 66 (~april 17 2018)
            // https://developers.google.com/web/updates/2018/03/clipboardapi
            if (navigator.clipboard) {
                navigator.clipboard.writeText(val).then(() => {
                    resolve(true);
                }).catch((err) => {
                    debug.warn('Clipboard readText error', err);
                    resolve(false);
                });
            } else {
                try {
                    resolve(document.execCommand('copy'));
                } catch (err) {
                    debug.warn('Clipboard copy error', err);
                    resolve(false);
                }
            }
        });
        promise.then(() => {
            this.textarea.blur();
        });
        return promise;
    },
    getBounds () {
        var selection = window.getSelection();
        if (
            selection &&
            selection.isCollapsed === false &&
            selection.rangeCount > 0
        ) {
            var startRange = selection.getRangeAt(0);
            var start = $(startRange.startContainer);
            var endRange = selection.getRangeAt(selection.rangeCount - 1);
            var end = $(endRange.endContainer);
            
            var startRow, endRow;
            if (start.closest(this.bufferView.el).length && end.is('body')) {
                // select all
                startRow = this.bufferView.scroll.log.$('.messageRow:first');
                endRow = this.bufferView.scroll.log.$('.messageRow:last');
                if (startRow.length && endRow.length) {
                    return [startRow, endRow];
                }
                return [];
            }
            
            // Make sure at least one end is in the log,
            // falling back to the viewport and catching it later on
            startRow = start.closest('.groupedLines__line, .log .row, .viewport');
            endRow = end.closest('.groupedLines__line, .log .row, .viewport');
            var startIsLine = startRow.is('.groupedLines__line, .row');
            var endIsLine = endRow.is('.groupedLines__line, .row');
            if (startIsLine || endIsLine) {
                if (startRow.is('.row')) {
                    // Walk forward to the nearest message row
                    if (!startRow.is('.messageRow')) {
                        startRow = startRow.nextAll('.messageRow:first');
                    }
                } else if (!startRow.is('.groupedLines__line')) {
                    // Default to the first message row
                    startRow = this.bufferView.scroll.log.$('.messageRow:first');
                }
                
                if (endRow.is('.row')) {
                    // Walk back to the nearest message row
                    if (!endRow.is('.messageRow')) {
                        endRow = endRow.prevAll('.messageRow:first');
                    }
                } else if (!endRow.is('.groupedLines__line')) {
                    // Default to the last message row
                    endRow = this.bufferView.scroll.log.$('.messageRow:last');
                }
                if (startRow.length && endRow.length) {
                    return [startRow, endRow];
                }
            }
        }
        return [];
    },
    rowsFromBounds (startRow, endRow) {
        if (startRow.is(endRow)) {
            return startRow;
        }
        // Ungroup start and end
        var ungroupedStart = startRow;
        var startRowParent = startRow;
        var ungroupedEnd = endRow;
        var endRowParent = endRow;
        if (startRow.is('.collapseGroup .messageRow')) {
            ungroupedStart = startRow.add(startRow.nextUntil(endRow, '.messageRow'));
            startRowParent = startRow.closest('.collapseGroup');
        }
        if (endRow.is('.collapseGroup .messageRow')) {
            ungroupedEnd = endRow.prevUntil(startRow, '.messageRow').add(endRow);
            endRowParent = endRow.closest('.collapseGroup');
        }
        if (startRow.is('.groupedLines__line')) {
            ungroupedStart = startRow.add(startRow.nextUntil(endRow, '.groupedLines__line'));
            startRowParent = startRow.closest('.messageRow');
        }
        if (endRow.is('.groupedLines__line')) {
            ungroupedEnd = endRow.add(endRow.prevUntil(startRow, '.groupedLines__line'));
            endRowParent = endRow.closest('.messageRow');
        }
        
        var rows;
        if (startRowParent.is(endRowParent)) {
            // Check again, we reassigned these and need to check if
            // start and end are both within the same collapseGroup
            rows = ungroupedStart.add(ungroupedEnd);
        } else {
            rows = ungroupedStart
                .add(startRowParent.nextUntil(endRowParent, '.messageRow, .collapseGroup.expanded, .expandJoinPart .joinPartGroup, .dateChange'))
                .add(ungroupedEnd);
        }
        var flattened = [];
        rows.each(function (i, row) {
            var $row = $(row);
            if ($row.is('.collapseGroup')) {
                // Ungroup any expanded collapseGroups in range
                flattened = flattened.concat($row.find('.messageRow').toArray());
            } else if ($row.find('.groupedLines').length) {
                // Ungroup any grouped lines in range
                flattened = flattened.concat($row.find('.groupedLines__line').toArray());
            } else {
                flattened.push(row);
            }
        });
        return $(flattened);
    },
    hide (immediate) {
        var state = {hide: true};
        if (immediate) {
            state.success = false;
        }
        this.extendState(state);
    },
    onSelectionChange (e) {
        var [startRow, endRow] = this.getBounds();
        if (!startRow || !endRow) {
            this.hide();
            return;
        }
        
        // Show the prompt for the user to click to copy
        this.setState(_.extend({}, INIT_STATE, {show: true, startRow, endRow}));
    },
    gatherText () {
        var full = this.rowsFromBounds(this.state.startRow, this.state.endRow);
        // Remove elements we don't want to copy
        var toExclude = [
            '.ignored'
        ];
        if (!this.model.isShowingJoinPart()) {
            toExclude.push('.joinPart');
        }
        if (!this.model.isCollapsingJoinPart()) {
            toExclude.push('.groupedJoinPart');
        }
        var excluded = full.not(toExclude.join(', ')).toArray();
        var rows = $(excluded.map(function (row) {
            return row.cloneNode(true);
        }));
        
        var toRemove = [
            '.avatar',
            '.author-realname',
            '.author-bot',
            '.channel-context',
            '.actualName',
            '.multiline-break',
            '.mode_pill',
            '.entityWrap',
            '.fileWrap',
            '.gistwrap',
            '.attachWrap',
            '.reactions',
            '.messageActions',
            '.reply__tooltip',
            '.reply__summary',
            '.reply__quote'
        ];
        if (this.model.session.getPref('emoji-disableconvert')) {
            toRemove.push('.emoconverted');
        } else {
            toRemove.push('.emocode:not(tt .emocode, pre.monoblock .emocode)');
        }
        toRemove.push('tt .emoconverted, pre.monoblock .emoconverted');
        rows.find(toRemove.join(', ')).remove();
        
        // Build up lines and set the textarea
        var lines = _.map(rows, function (row) {
            // Replace nbsp with space
            return $(row).text().replace(/\u00a0/g, ' ') + '\n';
        });
        
        this.textarea.value = lines.join('');
    }
});



// WEBPACK FOOTER //
// ./app/src/view/selection-copy.es6